import * as React from 'react';
import { ISelectFilterOption } from '../../../../../shop-ui/components/search-page/interfaces';
import CheckboxListItem from '../../../../../shop-ui/components/CheckboxListItem';
import { withMemo } from 'PyzShopUi/scripts/react/common/hoc/withMemo';

interface IBrandFilterOptionsProps {
    additionalClassName?: string;
    optionList: ISelectFilterOption[];
    isKeyboardFocusable?: boolean;

    onScrollChange?(event: React.UIEvent<HTMLUListElement, UIEvent>): void;

    onToggleItem?(value: string, isSelected: boolean): void;
}

const BrandFilterOptionsComponent: React.FunctionComponent<IBrandFilterOptionsProps> = props => {
    const displayItem = () => (
        props.optionList.map(option => (
            <CheckboxListItem
                key={option.value}
                label={option.label}
                value={option.value}
                isSelected={option.selected}
                additionalWrapperClassName='checkbox-menu__item'
                onClick={props.onToggleItem}
            />
        ))
    );

    return (
        <ul onScroll={props.onScrollChange} className={`checkbox-menu ${props.additionalClassName}`} {...(props.isKeyboardFocusable ? { 'tabIndex': 0 } : {})}>
            {displayItem()}
        </ul>
    );
};

BrandFilterOptionsComponent.defaultProps = {
    additionalClassName: '',
    onScrollChange: () => ({}),
    onToggleItem: () => ({}),
};

const BrandFilterOptions = withMemo(BrandFilterOptionsComponent);

export default BrandFilterOptions;
